import { types } from "mobx-state-tree";

const StatusCode = types.model('StatusCode', {
  code: types.identifierNumber,
  agentSelectable: types.optional(types.boolean, false),
  description: types.optional(types.string, ""),
});

export default StatusCode;
